import React, { Component } from "react";
import {
  primaryColor,
  textBlack,
  textPrimary,
  webFont
} from "../../config/theme";
import { Grid, Button } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import Fab from "@material-ui/core/Fab/Fab";
import Radio from "@material-ui/core/Radio";
import InputLabel from "@material-ui/core/InputLabel";
import { compose, graphql } from "react-apollo";
import { ADD_USER_PAYMENT } from "../../graphql/mutations/user";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import { NotificationManager } from "react-notifications";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import GetCardType from '../../utils/card-type';
import AddCard from "../AddCard";

import {getPaymentInfo} from "../../redux/user";

const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
const amex = "/images/amex.webp";
const discover = "/images/discover.webp";
const dinersclub = "/images/dinersclub.webp";
const jcb = "/images/jcb.webp";
const mastercard = "/images/mastercard.webp";
const visa = "/images/visa.webp";
const unionpay = "/images/unionpay.webp";
const othercc = "/images/cc-outline.webp";

class PaymentInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardType: "",
      loading: false,
      disableCancel: true,
      disableSubmit: true,
      showAddCard: false,
      formData: {
        cardName: "",
        validThru: "",
        cvvCode: "",
        cardNo: ""
      },
      errData: {
        cardName: "",
        validThru: "",
        cvvCode: "",
        cardNo: "",
        loading: false
      }
    };

    this.onCloseAddCard = this.onCloseAddCard.bind(this);
  }

  handleChange = (e, name) => {
    let { errData, formData, cardType } = this.state;
    switch (name) {
      case "cardNo":
        let cNo = e.target.value.replace("-", "");
        if (cNo == "") {
          errData.cardNo = "This Field can not be blank ";
        } else {
          errData.cardNo = "";
          cardType = GetCardType(cNo);
        }
        formData.cardNo = e.target.value
          .split("-")
          .join("")
          .split(" ")
          .join("");
        cardType = GetCardType(cNo);
        break;
      case "validThru":
        if (e.target.value == "") {
          errData.validThru = "This Field can not be blank ";
        } else {
          errData.validThru = "";
        }
        formData.validThru = e.target.value;
        break;
      case "cvvCode":
        if (e.target.value == "") {
          errData.cvvCode = "This Field can not be blank";
        } else if ( e.target.value != "" && isNaN(e.target.value)) {
          errData.cvvCode = "This is not valid cvv no";
        } else if (this.state.cardType.toLowerCase().startsWith('amex') && e.target.value.length !== 4) {
          errData.cvvCode = "This is not valid cvv no";
        } else if (!this.state.cardType.toLowerCase().startsWith('amex') && e.target.value.length !== 3) {
          errData.cvvCode = "This is not valid cvv no";
        } else {
          errData.cvvCode = "";
        }
        formData.cvvCode = e.target.value;
        break;
      case "cardName":
        formData.cardName = e.target.value;
        break;
    }
    this.setState({
      errData: { ...this.state.errData, ...errData, },
      cardType,
      formData: { ...this.state.formData, ...formData },
      disableCancel: false
    }, () => {
      const { formData } = this.state;
      if (formData.cardNo && formData.cvvCode && formData.validThru) {
        this.setState({ disableSubmit: false })
      }
    });
  };

  submitDetail = event => {
    event.preventDefault();
    const { addUserPayment, paymentInfo } = this.props;
    const { userId, dispatch } = this.props;

    let { formData, cardType } = this.state;
    if (!expiryRegex.test(formData.validThru)) {
      NotificationManager.error('Invalid expiry format', 'Add Card');
      return;
    }
    let enterDate = formData.validThru.split("/");

    if (
      formData.cardNo != "" &&
      formData.cvvCode != "" &&
      enterDate != "" && ((cardType.toLowerCase().startsWith('amex') && formData.cvvCode.length === 4) || (!cardType.toLowerCase().startsWith('amex') && formData.cvvCode.length === 3))
    ) {
      let payload = {
        type: "CARD",
        card: {
          number: formData.cardNo,
          expMonth: enterDate[0],
          expYear: enterDate[1],
          cvc: formData.cvvCode
        }
      };

      if (!!formData.cardName && formData.cardName.length > 5) {
        payload.card.nameOnCard = formData.cardName;
      }

      this.setState({ loading: true });

      addUserPayment({
        variables: {
          userId: this.props.userId,
          payment: payload
        }
      })
        .then(res => {
          if (!res || res === null) {
            NotificationManager.error('Please check if the card is already added', 'Add Card');
            return;
          }

          if (!res.data.addUserPayment) {
            NotificationManager.error('Please check if the card is already added', 'Add Card');
            this.setState({ loading: false });
            return;
          }

          dispatch(getPaymentInfo(userId));
          NotificationManager.info(
            "Payment Info Updated Successfully",
            "Payment Info"
          );
          this.setState({ loading: false, formData: {
              cardName: "",
              validThru: "",
              cvvCode: "",
              cardNo: "",
            }, cardType: "" });
        })
        .catch(err => {
          console.log(JSON.parse(JSON.stringify(err)));
          let errorObj = JSON.parse(JSON.stringify(err));
          if (errorObj.graphQLErrors) {
            errorObj.graphQLErrors.map(error => {
              NotificationManager.error(error.message, "Payment Info");
            });
          }
          this.setState({ loading: false });
        });
    } else {
      NotificationManager.error("All fields are required");
      this.setState({ loading: false });
    }

  };

  onCloseAddCard = () => {
    this.setState({ showAddCard: false });
  };

  render() {
    let { paymentInfo } = this.props;
    let userCards = <ListItem />;
    if (paymentInfo) {
      userCards = paymentInfo.map(payment => {
        return (
          <ListItem
            divider
            style={{ display: "flex", padding: 0 }}
          >
            <div>
              <p>
                ************{payment.card.last4}
              </p>
            </div>
            <div>
              <img src={payment.card.type.toLowerCase().startsWith('visa') ? visa : (
                payment.card.type.toLowerCase().startsWith('master') ? mastercard : (
                  payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ? amex : (
                    payment.card.type.toLowerCase().startsWith('disco') ? discover : (
                      payment.card.type.toLowerCase().startsWith('diner') ? dinersclub : (
                        payment.card.type.toLowerCase().startsWith('jc') ? jcb :
                          payment.card.type.toLowerCase().startsWith('uni') ? unionpay : ''
                      )
                    )
                  )
                )
              )} style={styles.cardImgInput} />
            </div>
            {/* <div>
              <Radio color="primary" checked />
            </div> */}
          </ListItem>
        );
      });
    }

    return (
      <div>
        <p style={styles.headerText}>Payment Info.</p>
        <form>
          <Grid container spacing={16}>
            <Grid item md={6} xs={11} sm={12}>
              {userCards.length > 0 && <div><Grid
              data-test-id={"pymtinfosavedcard"}

              item md={12} xs={11} sm={12}>
                <div>
                  <p style={styles.subHeaderText}>Saved cards</p>
                </div>
              </Grid>

              <Grid item style={{width: '95%'}} className="full-ipad-width">
                <List>{userCards}</List>
              </Grid></div>}
              <Grid item md={12} style={{marginTop: 40}}>
                <div
                  onClick={() => this.setState({ showAddCard: true })}
                  style={styles.addAnotherText}>
                  Add {userCards.length > 0 ? 'another' : ''} card
                </div>
              </Grid>
            </Grid>

            <AddCard show={this.state.showAddCard} close={this.onCloseAddCard} onSuccess={() => {}} />
          </Grid>
        </form>
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef,
    paymentInfo: state.user.paymentInfo
  };
};

const UserPaymentInfoWithData = compose(
  graphql(ADD_USER_PAYMENT, { name: "addUserPayment" })
)(PaymentInfo);
const UserUpdatePaymentInfo = connect(mapSateToProps)(UserPaymentInfoWithData);

export default UserUpdatePaymentInfo;

const styles = {
  cardImgInput: {
    marginLeft: 20,
    minHeight: 20,
    maxHeight: 60,
    minWidth: 61,
    maxWidth: 120
  },
  headerText: {
    fontSize: 30,
    textAlign: "left",
    margin: 0,
    paddingBottom: 10,
    fontFamily: webFont,
    fontWeight: 500,
  },
  subHeaderText: {
    fontSize: 18,
    textAlign: "left",
    margin: 0,
    paddingBottom: 10,
    fontFamily: webFont,
    fontWeight: "normal"
  },
  addAnotherText: {
    textAlign: "left",
    margin: 0,
    paddingBottom: 30,
    fontFamily: webFont,
    fontWeight: "normal",
    backgroundColor: primaryColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 200,
    color: '#ffffff',
    fontSize: 20,
    padding: '15px',
    borderRadius: 30,
    cursor: 'pointer'
  },
  inputButtonContainer: {
    display: "flex"
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "90%",
    height: "62%",
    paddingTop: 10,
    paddingBottom: 10
  },
  inputFullText: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "95%",
    height: "62%",
    paddingTop: 10,
    paddingBottom: 10
  },
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: 180,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    boxShadow: 'none',
    fontSize: 18,
  },
  disableButton: {
    borderRadius: 25,
    backgroundColor: '#dadada',
    border: "none",
    minWidth: 180,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    boxShadow: 'none',
    fontSize: 18,
  },
  frlabel: {
    fontFamily: webFont,
    fontSize: "20px",
    color: textPrimary,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30
  },
  ftText: {
    fontFamily: webFont,
    fontSize: "15px",
    color: textBlack,
    marginLeft: 80,
    fontWeight: 500,
    marginTop: 10
  },
  error: { fontSize: 12, color: "red", fontFamily: webFont }
};
